import axios from 'axios';
import authService from './services/auth.service';
import tokenService from './services/token.service';
import { router } from './router';
import {API_URL} from './parameters';

axios.interceptors.request.use((config) => {
    const accessHeader = tokenService.accessHeader();
    config.headers = accessHeader;
    return config;
}, (error) => {
    return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if(error.response.status === 401) {
        authService.logout();
        router.go();
    }
    return Promise.reject(error);

});

class ReadOnlyAPI {
    constructor(resource) {
        this.resource = resource;
        this.url_list = `${API_URL}/${this.resource}/`;
    }

    url_detail(pk) {
        return `${this.url_list}${pk}/`;
    }

    async list() {
        const response = await axios.get(this.url_list);
        return response.data;
    }

    async retrieve(pk) {
        const response = await axios.get(this.url_detail(pk));
        return response.data;
    }
}


class API extends ReadOnlyAPI {
    async partial_update(pk, object) {
        const response = await axios.patch(this.url_detail(pk), object);
        return response.data;
    }

    async create() {
        const response = await axios.post(this.url_list);
        return response.data;
    }
}

export const OppositionProtocols = new API('oppositions/workspaces');
export const OppositionDrwh = new API('oppositions/drwh');
export const ResetFakeData = new API('accounts/reset_fake_data');
export const CustomParagraphs = new API('customization/custom_paragraph');
